/**
 * Enlaces a los documentos legales (brief del cambio §5, ADR-SEC-018).
 *
 * Son los mismos en los tres entornos — el texto vive en el sitio público
 * (`quizoteca-homepage`) — así que no son un parámetro de operación y no van
 * a `.env.*`. Abren en pestaña nueva.
 */
export const LEGAL_TERMS_URL = 'https://quizoteca.com/terminos'
export const LEGAL_PRIVACY_URL = 'https://quizoteca.com/privacidad'

/** Identidad de este cliente ante `acceptLegalTerms` (enum del contrato). */
export const LEGAL_CLIENT_ID = 'quizoteca-admin' as const
